  window.searchIntegration = {
    addToCart: function(variantId, quantity = 1) {
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': quantity
        }],
        'sections': 'cart-drawer,cart-icon-bubble'
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        // Safety Check: Ensure sections were returned
        if (!data.sections) return;

        // --- FIX 1: Update Cart Icon Bubble (Header Count) ---
        // We catch errors here so they don't stop the drawer from opening
        try {
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections['cart-icon-bubble']) {
                // Directly inject the HTML instead of searching for an ID inside it
                cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }
        } catch (e) { console.error('Cart Icon Update Failed:', e); }

        // --- FIX 2: Update Cart Drawer ---
        try {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && data.sections['cart-drawer']) {
                const parsedHTML = new DOMParser()
                    .parseFromString(data.sections['cart-drawer'], 'text/html');
                
                // Try to find the <cart-drawer> element in the new data
                const newDrawerContent = parsedHTML.querySelector('cart-drawer');
                
                if(newDrawerContent) {
                    // Update content
                    cartDrawer.innerHTML = newDrawerContent.innerHTML;
                    
                    // Remove 'is-empty' class so the cart looks populated
                    cartDrawer.classList.remove('is-empty');
                    
                    // Open the drawer
                    if (typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                    }
                }
            }
        } catch (e) { console.error('Cart Drawer Update Failed:', e); }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
      });
    },

    chooseOptions: function(productUrl) {
      window.location.href = productUrl;
    }
  };
